import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Toaster } from 'react-hot-toast';
import AdminSidebar from '@/components/admin/AdminSidebar';
import AdminHeader from '@/components/admin/AdminHeader';

const AdminLayout: React.FC = () => {
  const [collapsed, setCollapsed] = useState(() => localStorage.getItem('admin-sidebar') === 'collapsed');
  const location = useLocation();
  const [fadeKey, setFadeKey] = useState(0);

  // Trigger a simple re-fade on route change without AnimatePresence
  useEffect(() => {
    setFadeKey((k) => k + 1);
  }, [location.pathname]);

  const toggle = (): void => {
    const next = !collapsed;
    setCollapsed(next);
    localStorage.setItem('admin-sidebar', next ? 'collapsed' : 'expanded');
  };

  return (
    <div className="min-h-screen bg-[#fafafa]">
      <AdminSidebar collapsed={collapsed} onToggle={toggle} />

      <motion.div
        animate={{ marginLeft: collapsed ? 64 : 240 }}
        transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
        className="min-h-screen flex flex-col"
      >
        <AdminHeader />

        <main className="flex-1 p-6 lg:p-8">
          <motion.div
            key={fadeKey}
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.25, ease: [0.22, 1, 0.36, 1] }}
            className="max-w-[1200px] mx-auto"
          >
            <Outlet />
          </motion.div>
        </main>
      </motion.div>

      <Toaster
        position="top-right"
        toastOptions={{
          duration: 3000,
          style: {
            zIndex: 99999,
            background: '#111',
            color: '#fff',
            fontSize: '13px',
            fontWeight: 600,
            borderRadius: '12px',
            padding: '12px 18px',
          },
          success: {
            iconTheme: { primary: '#22c55e', secondary: '#fff' },
          },
          error: {
            iconTheme: { primary: '#ef4444', secondary: '#fff' },
          },
        }}
        containerStyle={{ zIndex: 99999 }}
      />
    </div>
  );
};

export default AdminLayout;
